import { TableCell, TableRow } from "@mui/material";
import { headerCellStyle } from "./OrderTableStyles";

function OrderTableHeaderRow({isShippingDateUndecided}) {
 
  return (    
    <TableRow>
      <TableCell sx={headerCellStyle}>品名</TableCell>
      <TableCell sx={headerCellStyle}>産地</TableCell>
      <TableCell sx={headerCellStyle}>規格</TableCell>
      <TableCell sx={headerCellStyle}>価格</TableCell>
      <TableCell sx={headerCellStyle}>数量</TableCell>
      <TableCell sx={headerCellStyle}>備考</TableCell>
      {
        isShippingDateUndecided
          ? <TableCell sx={headerCellStyle}>出荷日</TableCell>
          : null
      }
    </TableRow>
  )
}

export default OrderTableHeaderRow;